import AppleIcon from "../images/Apple logo 1.svg";
import TeslaIcon from "../images/Tesla 1.svg";
import PfizerIcon from "../images/Pfizer-uk-logo-open-graph 1.svg";
import MKIcon from "../images/M&S 1.svg";
import BPIcon from "../images/BP 1.svg";
import ShoppingCart from '../images/shopping-cart.png';
import Icon2 from "../images/3 82.svg";
import Icon3 from "../images/3 83.svg";
import Icon4 from "../images/3 84.svg";
import Icon5 from "../images/4 74.svg";
import Icon6 from "../images/5 2.svg";
import Icon7 from "../images/7 11.svg";
import Project1 from "../images/project1.jpg";
import Project2 from "../images/project2.jpg";
import christmas from "../images/christmas.png";
import automobile from "../images/automobile.png";
import holidays from "../images/holidays.png";
import homeDeposit from "../images/homedeposit.png";
import emergencyFunds from "../images/emergencyFunds.png";
import investments from "../images/investments.png";
import education from "../images/education.png";
import godebtfree from "../images/godebtfree.svg";

export const SavingsEnvelopesImages = {education: education, christmas: christmas, automobile: automobile, holidays: holidays, homeDeposit: homeDeposit, emergencyFunds: emergencyFunds, investments: investments, goDebtFree: godebtfree, godebtfree: godebtfree};
export const CreateNewEnvelopeImages = [christmas, automobile, holidays, homeDeposit, emergencyFunds, investments, education, godebtfree];

export var monthsList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const monthShortList = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const stocksMockData = [
    {
        title: "Top Traded stocks this week",
        stocksList: [
            {
                icon: AppleIcon,
                title: "Apple",
                keyword: "APPL",
                price: 166.66,
                priceChangePercentage: 5.42,
                stocksAmount: 0.45,
                currency: "USD"
            },
            {
                icon: TeslaIcon,
                title: "Tesla", keyword: "TSLA",
                price: 600.66,
                priceChangePercentage: -5.42,
                stocksAmount: 0.16,
                currency: "USD"
            },
            {
                icon: PfizerIcon,
                title: "Pfizer",
                keyword: "PFE",
                price: 200.66,
                priceChangePercentage: 5.42,
                stocksAmount: 0.20,
                currency: "USD"
            },
            {
                icon: BPIcon,
                title: "BP PLC",
                keyword: "BP",
                price: 241.66,
                priceChangePercentage: -0.46,
                stocksAmount: 0.78,
                currency: "GBp"
            },
            {
                icon: MKIcon,
                title: "M&S",
                keyword: "MKS",
                price: 119.66,
                priceChangePercentage: 1.06,
                stocksAmount: 0.48,
                currency: "GBp"
            }
        ]
    },
    {
        title: "Top ESG Stocks",
        stocksList: [
            {
                icon: AppleIcon,
                title: "Apple",
                keyword: "APPL",
                price: 166.66,
                priceChangePercentage: 5.42,
                stocksAmount: 0.45,
                currency: "USD"
            },
            {
                icon: BPIcon,
                title: "BP PLC",
                keyword: "BP",
                price: 241.66,
                priceChangePercentage: -0.46,
                stocksAmount: 0.48,
                currency: "GBp"
            },
            {
                icon: MKIcon,
                title: "M&S",
                keyword: "MKS",
                price: 119.66,
                priceChangePercentage: 1.06,
                stocksAmount: 0.48,
                currency: "GBp"
            }
        ]
    },
    {
        title: "Top High Dividend Stocks",
        stocksList: [
            {
                icon: AppleIcon,
                title: "Apple",
                keyword: "APPL",
                price: 166.66,
                priceChangePercentage: 5.42,
                stocksAmount: 0.45,
                currency: "USD"
            },
            {
                icon: MKIcon,
                title: "M&S",
                keyword: "MKS",
                price: 119.66,
                priceChangePercentage: 1.06,
                stocksAmount: 0.48,
                currency: "GBp"
            }
        ]
    },
   
]

export const pastSpendingsMockData = [
     {amount: null, date: '1 Oct', id: 1, text: 'Waitrose',category:"Grocery"},
    {amount: null, date: '2 Oct', id: 2, text: 'Tesco',category:"Grocery"},
    {amount: 25.50, date: '3 Nov', id: 1, text: 'Trousers',category:"Wants"},
    {amount: 30.50, date: '12 Nov', id: 2, text: 'MacBook',category:"Wants"}
]
export const BudgetCategories = [
    "Grocery","Transport","Health and Fitness", "Utilities", "Personal Car", "Entertainment", "Investments"
]
export const UpcomingBudgetTransactions = [
    {amount: 28.50, date: '1 Oct', id: 1, text: 'Waitrose',category:BudgetCategories[1],subcategory:BudgetCategories[4], frequency:"Weekly"},
    {amount: 11.50, date: '2 Nov', id: 2, text: 'Tesco',category:BudgetCategories[2],subcategory:BudgetCategories[6],frequency:"Monthly"},
]

export const PastBudgetTransactions = [
    {amount: 25.50, date: '3 Nov', id: 1, text: 'Trousers',category:BudgetCategories[5],subcategory:BudgetCategories[3], frequency:"Weekly"},
    {amount: 30.50, date: '12 Nov', id: 2, text: 'MacBook',category:BudgetCategories[4],subcategory:BudgetCategories[1], frequency:"None"}
]

export const bugdetList = [
    {
        title:BudgetCategories[0],
        budgetAmount:250,
        spent:40,
        icon:ShoppingCart
    },
    {
        title:BudgetCategories[1],
        budgetAmount:100,
        spent:30,
        icon:Icon2
    },
    {
        title:BudgetCategories[2],
        budgetAmount:100,
        spent:5,
        icon:Icon3
    },
    {
        title:BudgetCategories[3],
        budgetAmount:250,
        spent:50,
        icon:Icon4
    },
    {
        title:BudgetCategories[4],
        budgetAmount:50,
        spent:50,
        icon:Icon5
    },
    {
        title:BudgetCategories[5],
        budgetAmount:540,
        spent:30,
        icon:Icon6
    },
    {
        title:BudgetCategories[6],
        budgetAmount:200,
        spent:0,
        icon:Icon7
    }
]

export const offsetProjects = [
    {
        img:Project2,
        heading:"Peruvian Amazon Forest Protection",
        place:"Amazon Forest, Peru",
        carbon:"8 per tonne",
    },
    {
        img:Project1,
        heading:"Cambodia Clean Water Project",
        place:"Cambodia",
        carbon:"7.5 per tonne",
    }
]